import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pap-year-verification',
  templateUrl: 'pap-year-verification.component.html',
  styleUrls: ['./pap-year-verification.component.less', '../../../shared/common.less'],
})

export class PapYearVerificationComponent implements OnInit {
  @Input() year: number;
  @Input() isExpanded: boolean = false;
  @Output() yearChange = new EventEmitter<number>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();

  needPap: boolean = undefined;
  minDate: string;
  minYear: number;
  maxYear: number;
  isValidated: boolean = false;

  constructor(
  ) {
    const today = new Date();
    this.minDate = today.toISOString().substring(0, 10);
    this.minYear = today.getFullYear();
    this.maxYear = today.getFullYear() + 1;
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }

  onEdit() {
    this.editRequested.emit();
  }


  get electionYear(): number {
    return this.year;
  }

  set electionYear(value: number) {
    this.year = value || null;
    this.yearChange.emit(this.year);
  }
  
  onYearChange() {
    this.yearChange.emit(this.year);
  }

  ngOnChanges(): void {
    
  }
  
  ngOnInit(): void {
  }
}
